import css from 'styled-jsx/css';
import { theme } from '@admitkard/ccl/style';

export const UniversityListingCss = css`
  .university-listing-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacingOld(5)} 0;
  }
  .university-listings {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacingOld(5)};
    width: 90%;
  }
  .custom-skeleton {
    box-sizing: border-box;
    width: 100%;
    margin: ${theme.spacingOld(3)} 0;
    border-radius: ${theme.shape.borderRadiusS};
  }
  .search-details {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    align-self: flex-start;
    padding: 0 ${theme.spacingOld(2)};
  }
  .clear-all-link {
    margin: ${theme.spacingOld(3)} 0;
    margin-left: auto;
  }
  .university-filter-container {
    width: 90%;
    display: flex;
    justify-content: space-between;
  }
  .university-sort-select {
    margin-left: auto;
  }
  @media ${theme.mediaQuery.tabletUp} {
    .university-listing-container {
      padding-top: ${theme.spacingOld(3)};
    }
    .search-details {
      flex-direction: row-reverse;
      align-items: center;
    }
    .university-listings {
      width: 80%;
    }
    .custom-skeleton {
      margin: 0;
      padding: ${theme.spacingOld(4)} ${theme.spacingOld(6)};
    }
    .university-filter-container {
      width: 80%;
    }
  }
`;
